import React from 'react';
import '../../css/dzbn.css';
import Grid from '@material-ui/core/Grid'

class Footer extends React.Component {
    render () {
        let footer1 = (
            <footer style={{width:"100%", marginTop: "10em"}}>
                <div className='firstColumnFirstdRow' >
                    <p> Департамент контроля и надзора за строительством</p>
                    <p> Государственного комитета по стандартизаци Республики Беларусь </p>
                    <p>220030, г. Минск, ул. Мясникова, 39</p>
                    <p>+375 (17) 226-54-35</p>
                    <p><a href="mailto:gosstroinadzor@tut.by">gosstroinadzor@tut.by</a></p>
                </div>
                <div className='firsColumnSecondRow'>
                    <p>© 2018 Департамент контроля и надзора за строительством Государственного комитета по стандартизаци Республики Беларусь. Все права защищены</p>
                    <p></p>
                    <p>Создание сайта: Belhard Development </p>
                </div>
            </footer>
        )
        
        let footer2=(
        <footer>
            <Grid container spasing={15}>
                    <Grid item lg={6} xs={12}>
                        <div className="custom">
                            <div className="footer-info-text">
                                Департамент контроля и надзора за строительством <br />Государственного комитета по стандартизаци Республики Беларусь
                            </div>
                            <div className="footer-info-text">
                                220048, г. Минск, ул. Мясникова, 39<br />
                                <b>+375 17 226-45-11</b>
                                <br />
                                <a href="mailto: gosstroinadzor@tut.by">dkns@mail.belpak.by</a>
                            </div>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <div className="custom">
                            <div className="footer-info-text footer-info-copyright">
                                © 2018 Департамент контроля и надзора за строительством Государственного комитета по стандартизаци Республики Беларусь. Все права защищены
                            </div>
                            <div className="footer-info-text">Создание сайта: Belhard Development</div></div>
                    </Grid>
            </Grid>
        </footer>);
        return (footer2);
        
    }
}

export default Footer



// WEBPACK FOOTER //
// ./assets/src/js/components/Footer.jsx